import { any, bool, func, object } from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { createSimpleLinkProps } from '../../../external/components/link/LinkUtils'
import { isEmpty, isUndefined } from '../../../external/utilities/GeneralUtils'
import {
  forwardToFacilityDayPasses,
  forwardToFacilityHourlySiteList,
  forwardToFacilityOverview,
  forwardToFacilitySiteList,
  forwardToFacilitySitesCalendar,
  forwardToSiteAndBookingDetails,
  getFacilityOverviewRoute,
  getFacilitySiteListRoute,
  getFacilitySitesCalendarRoute,
} from '../../../router/RouteManager'
import {
  getFacilityRedirectConfig,
  isLOBSupported,
} from '../../../utilities/ConfigUtils'
import { hasCamping } from '../../../utilities/FacilityUtils'
import {
  getRedirectObjForLOB,
  isLOBCampingOrDayUse,
  isLOBDayPass,
  isLOBHourlySites,
} from '../../../utilities/LOBUtils'
import {
  getNextAvailableDateObj,
  getProductSearchObjFromQuery,
  mergeQueries,
} from '../../../utilities/QueryParamUtils'
import {
  CONTRACT_ALL,
  redirect,
  updateRedirectConfig,
} from '../../../utilities/RedirectUtils'
import { injectRouterPropsForServer } from '../../shared/hoc/utilities/ServerRouter'
import { PAGE_FACILITY_OVERVIEW } from '../consts'
import OverviewLayout from './OverviewLayout'

const PAGE_ID = PAGE_FACILITY_OVERVIEW

class OverviewContainer extends Component {
  getFacilityLinkObj(
    facility,
    isFindNextAvailable = false,
    facilityAvailabilityStatus = null,
  ) {
    const facilityName = facility?.name
    const contractCode = facility?.details?.contrCode || 'CHUB'
    const facilityId = facility?.a1Id || facility?.id
    // facilityAvailabilityStatus = getFacilityAvailabilityStatus(facility),
    const facilityHasCamping = hasCamping(facility)

    let linkObj = null
    if (facility.details.crossOverCustomLanding) {
      if (!isEmpty(facility.details) && !isEmpty(facility.details.baseURL)) {
        linkObj = createSimpleLinkProps(facility.details.baseURL, false, true)
      }
    } else if (facilityHasCamping) {
      let link = ''
      const queryObj = getProductSearchObjFromQuery(this.props.location.query)
      if (isFindNextAvailable) {
        const query = {}
        mergeQueries(
          [getNextAvailableDateObj({ nextAvailableDate: 'true' }), queryObj],
          query,
        )
        link = getFacilitySitesCalendarRoute(
          facilityName,
          contractCode,
          facilityId,
          query,
        )
      } else if (
        !isUndefined(facilityAvailabilityStatus) &&
        !isEmpty(facilityAvailabilityStatus)
      ) {
        link = getFacilitySiteListRoute(
          facilityName,
          contractCode,
          facilityId,
          queryObj,
        )
      } else {
        link = getFacilityOverviewRoute(
          facilityName,
          contractCode,
          facilityId,
          queryObj,
        )
      }
      linkObj = createSimpleLinkProps(link)
    } else if (
      !isEmpty(facility.details) &&
      !isEmpty(facility.details.baseURL)
    ) {
      linkObj = createSimpleLinkProps(facility.details.baseURL, false, true)
    }

    return linkObj
  }

  onFacilitySelectRequest(
    facility,
    isFindNextAvailable = false,
    facilityAvailabilityStatus = null,
  ) {
    const facilityName = facility.name
    const contractCode = facility?.details?.contrCode || 'CHUB'
    const facilityId = facility?.a1Id || facility?.id
    // facilityAvailabilityStatus = getFacilityAvailabilityStatus(facility),
    const facilityHasCamping = hasCamping(facility)

    if (facility.details.crossOverCustomLanding) {
      if (!isEmpty(facility.details) && !isEmpty(facility.details.baseURL)) {
        this.onRedirectToFacilityRequest(facility.details.baseURL, true)
      }
    } else if (facilityHasCamping) {
      const queryObj = getProductSearchObjFromQuery(this.props.location.query)
      if (isFindNextAvailable) {
        const query = {}
        mergeQueries(
          [getNextAvailableDateObj({ nextAvailableDate: 'true' }), queryObj],
          query,
        )
        forwardToFacilitySitesCalendar(
          facilityName,
          contractCode,
          facilityId,
          query,
        )
      } else if (
        !isUndefined(facilityAvailabilityStatus) &&
        !isEmpty(facilityAvailabilityStatus)
      ) {
        forwardToFacilitySiteList(
          facilityName,
          contractCode,
          facilityId,
          queryObj,
        )
      } else {
        forwardToFacilityOverview(
          facilityName,
          contractCode,
          facilityId,
          queryObj,
        )
      }
    } else if (
      !isEmpty(facility.details) &&
      !isEmpty(facility.details.baseURL)
    ) {
      this.onRedirectToFacilityRequest(facility.details.baseURL, true)
    }
  }

  onRedirectToFacilityRequest(redirectURL, newWindow = true) {
    const { mainConfig, onRequestRedirect } = this.props
    const redirectConfig = getFacilityRedirectConfig(mainConfig, CONTRACT_ALL)

    if (!isEmpty(redirectConfig)) {
      updateRedirectConfig(redirectConfig, redirectURL, newWindow)
      onRequestRedirect(redirectConfig)
    }
  }

  render() {
    const {
      theme,
      intl,
      facility,
      params,
      isLoading,
      contractConfig,
      forwardToFacilitySiteList,
      forwardToSelectedProduct,
      mainConfig,
      brandConfig,
      onGoToLOBPageRequest,
    } = this.props
    if (isLoading) {
      return <div></div>
    }

    return (
      <div>
        <OverviewLayout
          contractConfig={contractConfig}
          theme={theme}
          intl={intl}
          facility={facility}
          params={params}
          forwardToFacilitySiteList={forwardToFacilitySiteList}
          forwardToSelectedProduct={forwardToSelectedProduct}
          onFacilitySelectRequest={this.onFacilitySelectRequest.bind(this)}
          getFacilityLinkObj={this.getFacilityLinkObj.bind(this)}
          mainConfig={mainConfig}
          brandConfig={brandConfig}
          pageId={PAGE_ID}
          onGoToLOBPageRequest={onGoToLOBPageRequest}
        />
      </div>
    )
  }

  static propTypes = {
    location: object,
    theme: any,
    intl: object,
    facility: object,
    params: object,
    isLoading: bool,
    contractConfig: object,
    forwardToFacilitySiteList: func,
    forwardToSelectedProduct: func,
    mainConfig: object,
    brandConfig: object,
    onGoToLOBPageRequest: func,
    onRequestRedirect: func,
  }
}

function mapStateToProps(state) {
  return {
    theme: state.application.theme,
    intl: state.backend.intl,
    facility: state.backend.facility.facility,
    isLoading: state.backend.isLoading,
    contractConfig: state.backend.config.contract,
    mainConfig: state.backend.config.main,
    brandConfig: state.backend.config.brand,
  }
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    forwardToFacilitySiteList: () => {
      const { splat, contractId, facilityId } = ownProps.params
      forwardToFacilitySiteList(
        splat,
        contractId,
        facilityId,
        ownProps.location.query,
      )
    },
    forwardToSelectedProduct: (productId) => {
      const { splat, contractId, facilityId } = ownProps.params
      forwardToSiteAndBookingDetails(
        splat,
        contractId,
        facilityId,
        productId,
        ownProps.location.query,
      )
    },
    onRequestRedirect: (redirectConfigForContract) => {
      redirect(redirectConfigForContract, dispatch)
    },
    onGoToLOBPageRequest: (lob, facility, mainConfig) => {
      const { splat, contractId, facilityId } = ownProps.params
      if (isLOBCampingOrDayUse(lob) && isLOBSupported(mainConfig, lob)) {
        forwardToFacilitySiteList(
          splat,
          contractId,
          facilityId,
          ownProps.location.query,
        )
      } else if (isLOBDayPass(lob) && isLOBSupported(mainConfig, lob)) {
        forwardToFacilityDayPasses(
          splat,
          contractId,
          facilityId,
          ownProps.location.query,
        )
      } else if (isLOBHourlySites(lob) && isLOBSupported(mainConfig, lob)) {
        forwardToFacilityHourlySiteList(
          splat,
          contractId,
          facilityId,
          ownProps.location.query,
        )
      } else {
        const redirectConfig = getFacilityRedirectConfig(
          mainConfig,
          CONTRACT_ALL,
        )
        const redirectObj = getRedirectObjForLOB(lob, facility.offeringSupport)

        if (!isEmpty(redirectConfig)) {
          updateRedirectConfig(redirectConfig, redirectObj.url, true)
          redirect(redirectConfig, dispatch)
        }
      }
    },
  }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    onGoToLOBPageRequest: (lob) =>
      dispatchProps.onGoToLOBPageRequest(
        lob,
        stateProps.facility,
        stateProps.mainConfig,
      ),
  })
}

export default injectRouterPropsForServer(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(OverviewContainer),
)
